import { Component, OnInit } from '@angular/core';
import { Region } from '../../../models/master-data/region.model';
import { AppMessages } from '../../../shared/constants/messages';
import { AppConstants } from '../../../shared/constants/constants';
import { RegionService } from './regions.service';
import { Utility } from '../../../common/utility';
import { DialogService } from '../../../shared/services/dialog.service';
import { TMBDataTableComponent } from '../../../components/data-table/data-table.component';
import { SharedService } from '../../../shared/services/share.services';

@Component({
  selector: 'master-data-region',
  templateUrl: 'regions-list.component.html',
  providers: [RegionService]
})

export class RegionListComponent extends TMBDataTableComponent implements OnInit {
  dataRow = new Array<Region>();

  constructor(public sharedService: SharedService,
    public dialogService: DialogService,
    public utility: Utility,
    private regionService: RegionService) {
        super(sharedService);
  }

  ngOnInit() {
    this.setPage({ offset: 0 });
}

    setPage(pageInfo) {
        this.page.pageNumber = pageInfo.offset;
        const param = {
            pageSize : this.page.size,
            currentPage : this.page.pageNumber + 1
        };
        this.regionService.getRegionsList(param).subscribe(
            (result) => {
                if (result) {
                    const data = result.json();
                    this.dataRow = data['list'];
                    this.page.pageNumber = pageInfo.offset;
                    this.page.totalElements = data['totalRecords'];
                }
            },
            error => {}
        );
    }
}



// WEBPACK FOOTER //
// D:/TMB/sr-git-v1/TMB.UI/src/app/pages/master-data/regions/regions-list.component.ts